module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Socket-eu-4e7b9141d2cd7e77597651bff4edc4e0.svg";